import { commitMutation, Environment } from "react-relay";
import { relayAuthEnvironment } from "@/RelayEnvironment";
import { graphql } from "relay-runtime";
import {
    CreateOrUpdateTranslationInput,
    CreateOrUpdateTranslationMutationResponse,
} from "@/Domains/TenantManagement/Mutations/__generated__/CreateOrUpdateTranslationMutation.graphql";
import { BaseError } from "@/Utils/BaseError";

export default (
    input: CreateOrUpdateTranslationInput,
    onCompleted: (error: Error | null, result?: boolean | null) => void,
) => {
    // @ts-ignore
    commitMutation(relayAuthEnvironment() as Environment, {
        mutation: graphql`
            mutation CreateOrUpdateTranslationMutation(
                $input: CreateOrUpdateTranslationInput!
            ) {
                CreateOrUpdateTranslationMutation(input: $input)
            }
        `,
        variables: {
            input: input,
        },
        onCompleted(result) {
            const res = result as CreateOrUpdateTranslationMutationResponse;
            const success: boolean | null | undefined =
                res.CreateOrUpdateTranslationMutation;

            if (success) {
                onCompleted(null, true);
                return;
            }

            throw new BaseError(
                "CreateOrUpdateTranslationMutation failed with an unexpected Error",
                {
                    context: {
                        component: input.component,
                        text: input.text,
                        language: input.language,
                    },
                },
            );
        },
        onError(err) {
            onCompleted(err);
        },
    });
};
